import { useNavigate } from "react-router-dom";
import { Home, Luggage, Siren, User, ChevronLeft } from "lucide-react";
import { DISCLAIMER_SHORT } from "@/lib/constants";

const TABS = [
  { key: "home", label: "Home", icon: Home, path: "/" },
  { key: "trips", label: "My Trips", icon: Luggage, path: "/trips" },
  { key: "emergency", label: "Emergency", icon: Siren, path: "/emergency" },
  { key: "profile", label: "Profile", icon: User, path: "/profile" },
];

export function AppShell({ active, title, showBack = false, onBack, headerRight, children, contentRef }) {
  const navigate = useNavigate();
  return (
    <div className="care-scope min-h-screen w-full flex justify-center bg-black">
      <div className="relative w-full max-w-[430px] h-screen bg-[#111111] shadow-2xl flex flex-col overflow-hidden print-frame">
        {(title || showBack || headerRight) && (
          <header className="z-40 bg-[#111111] border-b border-[#333333] text-[#F8FAFC] px-4 py-4 flex items-center gap-3 no-print shrink-0">
            {showBack && (
              <button
                data-testid="back-button"
                aria-label="Go back"
                onClick={onBack || (() => navigate(-1))}
                className="min-h-[44px] min-w-[44px] flex items-center justify-center rounded-xl hover:bg-white/10 transition-colors"
              >
                <ChevronLeft size={26} />
              </button>
            )}
            <h1 className="font-head text-xl font-bold truncate">{title}</h1>
            {headerRight && <div className="ml-auto shrink-0">{headerRight}</div>}
          </header>
        )}

        <main
          ref={contentRef}
          className="flex-1 overflow-y-auto no-scrollbar px-5 pt-5 pb-8"
        >
          {children}

          <footer className="mt-10 pt-6 border-t border-[#333333] no-print">
            <p className="text-xs text-[#A1A1AA] leading-relaxed" data-testid="footer-disclaimer">
              {DISCLAIMER_SHORT} Always consult your clinician before travel. In an emergency, call
              local emergency services.
            </p>
          </footer>
        </main>

        {active && (
          <nav
            aria-label="Primary"
            className="shrink-0 bg-[#111111] border-t border-[#333333] z-50 no-print"
          >
            <ul className="flex">
              {TABS.map((t) => {
                const Icon = t.icon;
                const isActive = active === t.key;
                const isEmergency = t.key === "emergency";
                const color = isEmergency
                  ? "text-[#EF4444]"
                  : isActive
                  ? "text-[#EF9F27]"
                  : "text-[#666666] hover:text-[#A1A1AA]";
                return (
                  <li key={t.key} className="flex-1">
                    <button
                      data-testid={`tab-${t.key}`}
                      aria-label={t.label}
                      aria-current={isActive ? "page" : undefined}
                      onClick={() => navigate(t.path)}
                      className={`w-full min-h-[64px] flex flex-col items-center justify-center gap-1 ${color} ${
                        isActive ? "font-bold" : "font-medium"
                      } transition-colors`}
                    >
                      <Icon size={26} strokeWidth={isActive || isEmergency ? 2.4 : 2} />
                      <span className="text-[11px]">{t.label}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
}
